import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistProfileProgressRequest } from '@/shared/api/requests/profile-progress/artist/request';
import { artistProfileProgress } from '@/shared/api/requests/profile-progress/artist/request';

export const useArtistProfileProgressQuery = (
  params: ArtistProfileProgressRequest,
  settings?: QuerySettings<typeof artistProfileProgress>
) =>
  useQuery({
    queryKey: ['ArtistProfileProgress', params.profileId],
    queryFn: () =>
      artistProfileProgress({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
